import { render, staticRenderFns } from "./master-plan.vue?vue&type=template&id=5503d9e4&scoped=true"
import script from "./master-plan.vue?vue&type=script&lang=js"
export * from "./master-plan.vue?vue&type=script&lang=js"
import style0 from "./master-plan.vue?vue&type=style&index=0&id=5503d9e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5503d9e4",
  null
  
)

export default component.exports